/* eslint-disable func-style */
import { disableBodyScroll, enableBodyScroll } from "//auriccosmetics.com/cdn/shop/t/47/assets/body_scroll_lock.js?v=61507118286993660021764101355";
import { EscapeObserver } from "//auriccosmetics.com/cdn/shop/t/47/assets/escapeObserver.js?v=40787582539029033611764101355";
import { getPromoBarHeight } from "//auriccosmetics.com/cdn/shop/t/47/assets/dom.js?v=175014698423836044041764101355";
import "//auriccosmetics.com/cdn/shop/t/47/assets/jquery-3.6.0.min.js?v=115860211936397945481764101355";
import "//auriccosmetics.com/cdn/shop/t/47/assets/cart.js?v=21215165042235021791764101886";

export const SELECTORS = {
  SECTION: 'cart-aside',
  SECTION_VISIBLE: 'cart-aside--show',
  CLICK_OFF: 'cart-aside__click-off',
  CLOSE: 'cart-aside__close',
  HEADER_CART: 'header-cart',
  HEADER_CART_SHOW: 'header-cart--show',
};

export const initCartAside = () => {
  const section = document.getElementById(SELECTORS.SECTION);
  const clickOff = document.querySelector(`.${SELECTORS.CLICK_OFF}`);
  const headerCart = document.getElementById(SELECTORS.HEADER_CART);

  const adjustCartAside = () => {
    const promoBarHeight = getPromoBarHeight();

    if (promoBarHeight > 0) {
        let offset = Math.max(0, promoBarHeight - window.scrollY);
      section.style.top = `${offset}px`;
      section.style.height = `calc(100% - ${offset}px)`;
    } else {
      section.style.top = '0';
      section.style.height = '100%';
    }
  };

  if (section && headerCart) {
    adjustCartAside();

    const cartCloseButton = section.querySelector(`.${SELECTORS.CLOSE}`);
    cartCloseButton.addEventListener('click', closeCartAside);

    clickOff.addEventListener('click', closeCartAside);

    headerCart.addEventListener('click', adjustCartAside);
    headerCart.addEventListener('click', openCartAside);
    EscapeObserver.onEscape(closeCartAside);

    window.addEventListener('load', adjustCartAside);
    window.addEventListener('resize', debounce(adjustCartAside));

    window.cartAsidedLoaded = true;
  }
};

export function isOpened() {
  const section = document.getElementById(SELECTORS.SECTION);
  return section ? section.classList.contains(SELECTORS.SECTION_VISIBLE) : false;
}

const SCROLL_LOCK_OPTS = {
  reserveScrollBarGap: true,
};

export function openCartAside() {
  const section = document.getElementById(SELECTORS.SECTION);
  const headerCart = document.getElementById(SELECTORS.HEADER_CART);
  const clickOff = document.querySelector(`.${SELECTORS.CLICK_OFF}`);
  section.classList.toggle(SELECTORS.SECTION_VISIBLE);
  headerCart.classList.toggle(SELECTORS.HEADER_CART_SHOW);
  
  if (isOpened()) {
    disableBodyScroll(section);
    $(clickOff).show();
  } else {
    enableBodyScroll(section);
    $(clickOff).hide();
  }
}

export function closeCartAside() {
  const section = document.getElementById(SELECTORS.SECTION);
  const headerCart = document.getElementById(SELECTORS.HEADER_CART);
  const clickOff = document.querySelector(`.${SELECTORS.CLICK_OFF}`);

  section.classList.remove(SELECTORS.SECTION_VISIBLE);
  headerCart.classList.remove(SELECTORS.HEADER_CART_SHOW);
  enableBodyScroll(section);
  $(clickOff).hide();
}

window.addEventListener('load', () => {
  if (!window.cartAsidedLoaded) {
    initCartAside();
  }
});